import { useContext, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  useToast,
  ModalHeader,
  useBreakpointValue,
  Flex,
} from "@chakra-ui/react";

import { appRequest } from "routes";
import CustomOnboarding from "../../CustomOnboarding/CustomOnboarding/CustomOnboarding";
import { AppContext } from "AppProvider/AppContext";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  id?: string;
  handleGet: () => void;
  formValues: any;
};

export default function EditFormModal({
  isOpen,
  onClose,
  id,
  handleGet,
  formValues,
}: ModalProps): JSX.Element {
  let width = "94vw";
  const isMobileView = useBreakpointValue({ base: true, lg: false });

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full">
      <ModalOverlay />
      <ModalContent
        position="fixed"
        right={isOpen ? "0" : `-${width}`}
        top="0"
        height="100vh"
        width={!isMobileView ? width : "100vw"}
        animation={`${
          isOpen ? "slideIn" : "slideOut"
        } 0.8s ease-in-out forwards`}
      >
        <ModalHeader
          fontSize={{ base: "1rem", md: "1.6rem" }}
          color="teal.300"
          fontWeight="700"
          p=".6rem .6rem"
          ml="1rem"
          textTransform="capitalize"
        >
          Edit Form
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <CustomOnboarding
            type="edit"
            formValues={formValues}
            handleGet={handleGet}
            id={id}
          />
        </ModalBody>
      </ModalContent>
      <style>
        {`
          @keyframes slideIn {
            from {
              right: -${width};
            }
            to {
              right: 0;
            }
          }
          @keyframes slideOut {
            from {
              right: 0;
            }
            to {
              right: -${width};
            }
          }
          `}
      </style>
    </Modal>
  );
}
